import { apiClient } from '@features/shared/api/client'
import type { ResolvedConfigurationResponse } from './contracts'
import type {
  ResolvedAppDataTypeConfiguration,
  ResolvedConfiguration,
  ResolvedPreferenceConfiguration,
} from '../models'

export async function getConfiguration(signal?: AbortSignal): Promise<ResolvedConfiguration> {
  const { data } = await apiClient.get<ResolvedConfigurationResponse>('/configuration', { signal })

  return {
    app_user_id: data.app_user_id ?? null,
    is_administrator: data.is_administrator ?? false,
    modules: data.modules,
    system_tables: data.system_tables ?? {},
    settings: data.settings ?? {},
    preferences: (data.preferences ?? {}) as ResolvedPreferenceConfiguration,
    app_data_types: (data.app_data_types ?? {}) as Record<string, ResolvedAppDataTypeConfiguration>,
  }
}
